var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-30-3H70v70H-30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.667h18.333V18H5v-3.333zm0-3.334h18.333V8H5v3.333zm0 13.334h11.667v-3.334H5v3.334zm25.017-5.217l1.183-1.183c.65-.65 1.7-.65 2.35 0l1.183 1.183c.65.65.65 1.7 0 2.35l-1.183 1.183-3.533-3.533zm-1.184 1.183L20 29.467V33h3.533l8.834-8.833-3.534-3.534z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoap);
export default __webpack_public_path__ + "static/media/soap.a0411ee68b086c4f7862174acfe57a84.svg";
export { ForwardRef as ReactComponent };